// Tours quoted on WhatsApp (no payment on the site): price unit, booking panel and the quote dialog.
export default {
  quote: {
    title: 'Get a quote',
    unit: { boat: 'for the whole boat', schooner: 'for the whole schooner', group: 'for the group' },
    calendarPrice: { boat: '{{price}} for the whole boat', schooner: '{{price}} for the whole schooner', group: '{{price}} for the group' },
    priceLine: { boat: 'Whole boat', schooner: 'Whole schooner', group: 'Private group' },
    peopleTitle: 'How many people',
    people: 'People',
    peopleHint: 'Everyone going on the tour',
    estimate: 'Reference price',
    badge: 'Quote on WhatsApp',
    note: 'No payment on the website: pick the date and how many people are going, and our team replies on WhatsApp whether it is available.',
    ask: 'Ask for a quote on WhatsApp',
    askShort: 'Ask for a quote',
    secure: 'No payment on the website: our team answers your quote on WhatsApp.',
    count_one: '{{count}} person',
    count_other: '{{count}} people',
    adults_one: '{{count}} adult',
    adults_other: '{{count}} adults',
    children_one: '{{count}} child',
    children_other: '{{count}} children',
    babies_one: '{{count}} baby',
    babies_other: '{{count}} babies',
    modal: {
      title: 'Ask for a quote',
      lead: 'Type your name: WhatsApp opens with the request ready, you only have to send it.',
      tour: 'Tour',
      date: 'Date',
      people: 'People',
      name: 'Full name',
      namePlaceholder: 'First and last name',
      nameError: 'Please type your full name.',
      send: 'Send on WhatsApp',
      hint: 'Our team replies on WhatsApp whether the date is available.',
      close: 'Close',
      sentTitle: 'Request ready on WhatsApp',
      sentText: 'Send the message on WhatsApp. Our team replies whether the date is available.',
      again: 'Open WhatsApp again',
      done: 'Done',
    },
  },
};
